module.exports = __webpack_public_path__ + "static/laura_01-a0b3e18d66946ba5bad7558c8ee33ae0.jpg";